import styles from './anzeigenSaeuleRow.module.css';
import AnzeigenSaeule from './AnzeigenSaeule';

function AnzeigenSaeuleRow({ list }) {
    return (
        <div className={styles.container}>
            {list.map((item, index) => (
                <AnzeigenSaeule
                    key={index}
                    icon={item.icon}
                    iconAlt={item.iconAlt}
                    text_html={item.text_html}
                    iconBig={item.iconBig}
                />
            ))}
        </div>
    );
}

export default AnzeigenSaeuleRow;
